import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex items-center w-full" }
const _hoisted_3 = {
  key: 1,
  class: "w-full"
}
const _hoisted_4 = { class: "flex items-center w-full" }
const _hoisted_5 = {
  key: 2,
  class: "w-full"
}
const _hoisted_6 = {
  key: 3,
  class: "flex w-full justify-center"
}
const _hoisted_7 = { class: "flex items-center mx-2 text-lg text-gray-800" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "new" }, "Nueva unidad", -1)
const _hoisted_9 = { class: "flex items-center mx-2 text-lg text-gray-800" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "existing" }, "Unidad existente", -1)
const _hoisted_11 = {
  key: 4,
  class: "flex w-full flex-wrap lg:flex-row sm:flex-col"
}
const _hoisted_12 = { class: "lm:w-full lm:mt-0 mx-auto lg:mt-7 hover:cursor-pointer" }
const _hoisted_13 = {
  key: 5,
  class: "flex w-full"
}
const _hoisted_14 = { class: "w-full" }
const _hoisted_15 = { class: "flex justify-between mt-4" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  key: 1,
  class: "icon-spin"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1)
const _hoisted_19 = [
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextField = _resolveComponent("TextField")!
  const _component_inputChipAuxVue = _resolveComponent("inputChipAuxVue")!
  const _component_Selector = _resolveComponent("Selector")!
  const _component_SearchSelector = _resolveComponent("SearchSelector")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Alert = _resolveComponent("Alert")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Modal, {
      title: ``,
      onOnClose: _ctx.closeModal,
      visible: _ctx.showModalAdd,
      "onUpdate:visible": _cache[17] || (_cache[17] = (e) => _ctx.showModalAdd = e)
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("button", {
            class: "px-4 py-2 mr-2 rounded-md bg-gray-300 hover:bg-gray-400 focus:bg-gray-400",
            onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, "Cancelar"),
          _createElementVNode("button", {
            class: _normalizeClass(["px-4 py-2 rounded-md bg-primary text-white hover:bg-green-600 focus:bg-green-600", { 'opacity-50 cursor-not-allowed disabled:pointer-events-none': !_ctx.isFieldsFilled }]),
            disabled: !_ctx.isFieldsFilled
          }, [
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.saveUser && _ctx.saveUser(...args)))
                }, _toDisplayString(_ctx.action === 'update' ? 'Editar' : 'Agregar'), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_17, _hoisted_19))
          ], 10, _hoisted_16)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_TextField, {
          label: "Primer nombre",
          model: _ctx.firsName,
          "onUpdate:model": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.firsName) = $event)),
          type: "text",
          name: "descripcion",
          placeholder: 'Juan'
        }, null, 8, ["model"]),
        _createVNode(_component_TextField, {
          label: "Apellido",
          model: _ctx.lastName,
          "onUpdate:model": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lastName) = $event)),
          type: "text",
          name: "apellido",
          placeholder: 'Perez'
        }, null, 8, ["model"]),
        _createVNode(_component_TextField, {
          label: "Teléfono",
          model: _ctx.phone,
          "onUpdate:model": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.phone) = $event)),
          type: "text",
          name: "Telefono",
          "has-error": _ctx.hasPhoneError,
          placeholder: '+569xxxxxxxx',
          "error-message": (_ctx.phone && _ctx.phone.trim().length === 0) ? 'El teléfono está vacío' : 'El teléfono no es válido. Verifique que no esté mal escrito'
        }, null, 8, ["model", "has-error", "error-message"]),
        _createVNode(_component_TextField, {
          label: "Correo electrónico",
          name: "email",
          type: "string",
          model: _ctx.email,
          "onUpdate:model": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.email) = $event)),
          class: "w-full",
          "has-error": _ctx.hasEmailError,
          placeholder: 'ejemplo@gmail.com',
          "error-message": (_ctx.email && _ctx.email.trim().length === 0) ? 'El correo electrónico está vacío' : 'Correo electrónico no válido. Verifique que no esté mal escrito'
        }, null, 8, ["model", "has-error", "placeholder", "error-message"]),
        _createVNode(_component_TextField, {
          label: "Profesión",
          model: _ctx.profession,
          "onUpdate:model": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.profession) = $event)),
          type: "text",
          name: "profesion",
          placeholder: 'Programador'
        }, null, 8, ["model"]),
        (_ctx.hasReducedCapacity == true)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_TextField, {
                label: "Discapacidad",
                class: "mt-5",
                model: _ctx.reducedCapacityDetails,
                "onUpdate:model": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.reducedCapacityDetails) = $event)),
                type: "text",
                name: "discapacidad"
              }, null, 8, ["model"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_TextField, {
            label: "Almacen",
            model: _ctx.warehouseSpace,
            "onUpdate:model": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.warehouseSpace) = $event)),
            type: "text",
            name: "almacen",
            placeholder: 'c124',
            class: "flex-grow mr-4"
          }, null, 8, ["model"]),
          _createElementVNode("button", {
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.addWareHouse && _ctx.addWareHouse(...args))),
            class: "px-4 h-8 rounded-md bg-primary text-white hover:bg-green-600 mt-2 focus:bg-green-600 hover:cursor-pointer"
          }, " Añadir ")
        ]),
        (_ctx.wareHouses.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_inputChipAuxVue, {
                array: _ctx.wareHouses,
                onDrop: _ctx.dropWareHouse
              }, null, 8, ["array", "onDrop"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_TextField, {
            label: "Estacionamiento",
            model: _ctx.parkingSpace,
            "onUpdate:model": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.parkingSpace) = $event)),
            type: "text",
            name: "Estacionamiento",
            placeholder: 'b24',
            class: "flex-grow mr-4"
          }, null, 8, ["model"]),
          _createElementVNode("button", {
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.addParking && _ctx.addParking(...args))),
            class: "px-4 h-8 rounded-md bg-primary text-white hover:bg-green-600 mt-2 focus:bg-green-600 hover:cursor-pointer"
          }, " Añadir ")
        ]),
        (_ctx.parkings.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_inputChipAuxVue, {
                array: _ctx.parkings,
                onDrop: _ctx.dropParking
              }, null, 8, ["array", "onDrop"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.action === 'create')
          ? (_openBlock(), _createElementBlock("section", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: "new",
                  name: "unitType",
                  value: "new",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.unitType) = $event)),
                  class: "mr-2 w-5 h-5"
                }, null, 512), [
                  [_vModelRadio, _ctx.unitType]
                ]),
                _hoisted_8
              ]),
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: "existing",
                  name: "unitType",
                  value: "existing",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.unitType) = $event)),
                  class: "mr-2 w-5 h-5"
                }, null, 512), [
                  [_vModelRadio, _ctx.unitType]
                ]),
                _hoisted_10
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.action === 'create' && _ctx.unitType === 'new')
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_component_Selector, {
                class: "w-full sm:w-full lg:w-1/5 mr-2 mt-2",
                items: _ctx.blockList,
                selectedItem: Number(_ctx.blockId),
                placeHolder: 'Block',
                label: 'Selección de Block',
                onUpdate: _ctx.onUpdateBlockId
              }, null, 8, ["items", "selectedItem", "onUpdate"]),
              _createVNode(_component_Selector, {
                class: "w-full sm:w-full lg:w-1/5 mr-2 mt-2",
                items: _ctx.establishments,
                selectedItem: Number(_ctx.establishmentType),
                placeHolder: 'Tipo de establecimiento',
                label: 'Establecimiento',
                onUpdate: _ctx.onUpdateModelEstablishment
              }, null, 8, ["items", "selectedItem", "onUpdate"]),
              _createVNode(_component_TextField, {
                label: "Pisos",
                model: _ctx.floor,
                "onUpdate:model": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.floor) = $event)),
                type: "number",
                name: "numBlock",
                class: "w-full sm:w-full lg:w-1/6 mr-2 mt-2 ml-4"
              }, null, 8, ["model"]),
              _createVNode(_component_TextField, {
                label: "Dirección de unidad",
                model: _ctx.address,
                "onUpdate:model": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.address) = $event)),
                type: "text",
                name: "direccion",
                placeholder: 'Direccion 123',
                class: "flex-grow mr-4 w-full sm:w-full lg:w-1/6 mt-2 ml-4"
              }, null, 8, ["model"]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("button", {
                  class: "px-4 h-8 rounded-md bg-primary text-white hover:bg-green-600 mt-2 focus:bg-green-600 hover:cursor-pointer",
                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.addUnit && _ctx.addUnit(...args)))
                }, "Añadir")
              ])
            ]))
          : (_ctx.action === 'update' || _ctx.unitType === 'existing')
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (_ctx.unitsList)
                  ? (_openBlock(), _createBlock(_component_SearchSelector, {
                      key: 0,
                      class: "'w-full'",
                      label: 'Seleccione una Unidad',
                      placeHolder: 'Seleccione la unidad',
                      items: _ctx.formattedUnitList,
                      searchKey: 'name',
                      onSelect: _ctx.onSelect
                    }, null, 8, ["items", "onSelect"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_inputChipAuxVue, {
            itemParameter: 'address',
            array: _ctx.units,
            onAdd: _ctx.addUnit,
            onDrop: _ctx.dropUnit
          }, null, 8, ["array", "onAdd", "onDrop"])
        ])
      ]),
      _: 1
    }, 8, ["onOnClose", "visible"]),
    (_ctx.showAlert)
      ? (_openBlock(), _createBlock(_component_Alert, {
          key: 0,
          type: _ctx.alertType,
          message: _ctx.showAlertMessage
        }, null, 8, ["type", "message"]))
      : _createCommentVNode("", true)
  ]))
}